import {
  SET_BAG,
  START_REMOVE_BAG_ITEM,
  FINISH_REMOVE_BAG_ITEM,
  SHOW_RESERVATION_MESSAGE,
  HIDE_RESERVATION_MESSAGE,
  BAG_ERROR,
  DISMISS_BAG_ERROR,
  SET_LOADING
} from "./constants";

export {
  SET_BAG,
  START_REMOVE_BAG_ITEM,
  FINISH_REMOVE_BAG_ITEM,
  SHOW_RESERVATION_MESSAGE,
  HIDE_RESERVATION_MESSAGE,
  START_CHECKOUT,
  BAG_ITEM_DELETE_TRANSITION_END,
  BAG_ERROR,
  DISMISS_BAG_ERROR,
  SET_LOADING
} from "./constants";

export { deleteBagItem, startCheckout } from "./actions";

export {
  getBag,
  getLoading,
  getBagItems,
  getBagSummary,
  getTotalPrice,
  getTotalPriceText,
  getTotalQuantity,
  displayReservationMessage,
  bagError,
  dismissBagError,
  getUpdated,
  bagItemDeleteTransitionEnd
} from "./selectors";

const initialState = {
  summary: {
    totalPrice: {}
  },
  loading: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BAG: {
      const { bag, messages } = action.payload;
      return {
        ...state,
        ...bag,
        messages,
        bagError: false,
        loading: false
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case START_REMOVE_BAG_ITEM: {
      return {
        ...state
      };
    }
    case SHOW_RESERVATION_MESSAGE: {
      return {
        ...state,
        displayReservationMessage: true
      };
    }
    case HIDE_RESERVATION_MESSAGE: {
      return {
        ...state,
        displayReservationMessage: false
      };
    }

    case BAG_ERROR: {
      return {
        ...state,
        bagError: true,
        loading: false
      };
    }
    case DISMISS_BAG_ERROR: {
      return {
        ...state,
        bagError: false
      };
    }
    case FINISH_REMOVE_BAG_ITEM: {
      return {
        ...state,
        lastItemRemoved: action.itemId
      };
    }
    default:
      return state;
  }
};
